import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

export const Layout = (props) => {
    const { children } = props;
    return (
        <>
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Sidebar />
                <div className="layout-page">
                    <div className="content-wrapper">
                        {children}
                    </div>
                </div>
            </div>
        </div>
        </>
        
    )
}